import { Injectable } from '@angular/core';
import {
  TranslocoLoader,
  getLangFromScope,
  Translation,
} from '@ngneat/transloco';
import { ScopeRegistry } from './scope-registry';
import { ResolverRegistry } from './resolver-registry';
import { DefaultHttpResolver } from './default-http.resolver';
import { Resolver } from '../types';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TranslationLoader implements TranslocoLoader {
  constructor(
    private defaultHttpLoader: DefaultHttpResolver,
    private scopeRegistry: ScopeRegistry,
    private resolverRegistry: ResolverRegistry
  ) {}

  getTranslation(
    langParam: string,
    data?: { scope: string }
  ): Observable<Translation> {
    const lang = getLangFromScope(langParam);
    if (data?.scope) {
      const source = this.scopeRegistry.get(data.scope);

      if (source != null) {
        const resolver = this.resolverRegistry.get(source) as Resolver;
        if (resolver) {
          return resolver.load(lang, data?.scope);
        }
        console.warn(
          `Translation Resolver ${source} not found. Fallback to default resolver.`
        );
      }
    }
    return this.defaultHttpLoader.load(lang, data?.scope);
  }
}
